export default __webpack_public_path__ + "static/media/EAST1070.34I-34194_-18439_0.734c16b7.jpg";